import { format } from 'date-fns';
import { ru } from 'date-fns/locale/ru';

const UTCShortFormat = 'yyyy-MM-dd';

export const formatDate = (dateVal: Date | string | number, dateFormat = UTCShortFormat) =>
  format(new Date(dateVal), dateFormat, { locale: ru });
